import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntegrationFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 0C6.23858 0 4 2.23858 4 5C4 7.76142 6.23858 10 9 10C11.7614 10 14 7.76142 14 5C14 2.23858 11.7614 0 9 0Z",
			fill: "#111111"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 12C2.23858 12 0 14.2386 0 17C0 18.6569 1.34315 20 3 20H9.40901C9.26003 19.6491 9.17593 19.2639 9.17173 18.8596L9.16713 18.4161L8.85678 18.0992C7.71441 16.9329 7.71441 15.0671 8.85678 13.9008L9.16713 13.5839L9.17173 13.1404C9.17593 12.7361 9.26003 12.3509 9.40901 12H5Z",
			fill: "#111111"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H15.01C15.5623 17 16.01 16.5523 16.01 16C16.01 15.4477 15.5623 15 15.01 15H15Z",
			fill: "#111111"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.6997 11.2856C15.311 10.9048 14.689 10.9048 14.3003 11.2856L13.4089 12.1587L12.1612 12.1716C11.617 12.1773 11.1773 12.617 11.1716 13.1612L11.1587 14.4089L10.2856 15.3003C9.9048 15.689 9.9048 16.311 10.2856 16.6997L11.1587 17.5911L11.1716 18.8388C11.1773 19.383 11.617 19.8227 12.1612 19.8284L13.4089 19.8413L14.3003 20.7144C14.689 21.0952 15.311 21.0952 15.6997 20.7144L16.5911 19.8413L17.8388 19.8284C18.383 19.8227 18.8227 19.383 18.8284 18.8388L18.8413 17.5911L19.7144 16.6997C20.0952 16.311 20.0952 15.689 19.7144 15.3003L18.8413 14.4089L18.8284 13.1612C18.8227 12.617 18.383 12.1773 17.8388 12.1716L16.5911 12.1587L15.6997 11.2856ZM14.5211 13.8689L15 13.3998L15.4789 13.8689C15.6633 14.0494 15.9103 14.1517 16.1683 14.1544L16.8386 14.1614L16.8456 14.8317C16.8483 15.0897 16.9506 15.3367 17.1311 15.5211L17.6002 16L17.1311 16.4789C16.9506 16.6633 16.8483 16.9103 16.8456 17.1683L16.8386 17.8386L16.1683 17.8456C15.9103 17.8483 15.6633 17.9506 15.4789 18.1311L15 18.6002L14.5211 18.1311C14.3367 17.9506 14.0897 17.8483 13.8317 17.8456L13.1614 17.8386L13.1544 17.1683C13.1517 16.9103 13.0494 16.6633 12.8689 16.4789L12.3998 16L12.8689 15.5211C13.0494 15.3367 13.1517 15.0897 13.1544 14.8317L13.1614 14.1614L13.8317 14.1544C14.0897 14.1517 14.3367 14.0494 14.5211 13.8689Z",
			fill: "#111111"
		})
	]
});
const ForwardRef = forwardRef(SvgIntegrationFilled);
export default ForwardRef;
